/**
 * Reading the round form, shared by the host's screen and a guest's so Record Round, a guest's submission and the live preview all
 * see the form the same way.
 */

import type { HkosToggles } from '../rules/hkos';
import type { WinContext } from '../rules/types';
import { esc } from './helpers';

export type Circumstances = Pick<
  WinContext,
  'robbingKong' | 'kongReplacement' | 'lastWallTile' | 'lastDiscard' | 'heavenlyHand' | 'earthlyHand' | 'winDoubleKong'
>;

/** The ticked extras (robbing a kong, last wall tile ...). A box the House Rules do not show counts as not ticked. */
export function readCircumstances(root: ParentNode): Circumstances & { heavenlyHand: boolean } {
  const on = (id: string): boolean => root.querySelector<HTMLInputElement>(`#${id}`)?.checked ?? false;
  return {
    robbingKong: on('robbingKong'),
    kongReplacement: on('kongReplacement'),
    lastWallTile: on('lastWallTile'),
    lastDiscard: on('lastDiscard'),
    heavenlyHand: on('heavenlyHand'),
    earthlyHand: on('earthlyHand'),
    winDoubleKong: on('winDoubleKong'),
  };
}

/** Which extras are already ticked (a correction or a scan coming back to the form). */
export type CircumstancePrefill = Partial<Record<keyof Circumstances, boolean>>;

const EXTRAS: { id: keyof Circumstances & keyof HkosToggles; label: string }[] = [
  { id: 'robbingKong', label: 'Robbing a kong' },
  { id: 'kongReplacement', label: 'Kong replacement win' },
  { id: 'lastWallTile', label: 'Last wall tile' },
  { id: 'lastDiscard', label: 'Last discard' },
  { id: 'heavenlyHand', label: 'Heavenly Hand (dealer, untouched starting hand)' },
  { id: 'earthlyHand', label: "Earthly Hand (claimed dealer's first discard)" },
  { id: 'winDoubleKong', label: 'Win Double Kong' },
];

/** The tick-boxes for the extras the House Rules switch on — only those are offered, so a rule that is off never shows. */
export function circumstantialHtml(toggles: HkosToggles, prefill?: CircumstancePrefill): string {
  return EXTRAS.map((e) =>
    toggles[e.id]
      ? `<label class="checkbox-row"><input type="checkbox" id="${e.id}" ${prefill?.[e.id] ? 'checked' : ''} /> ${esc(e.label)}</label>`
      : '',
  ).join('');
}
